module.exports = __webpack_public_path__ + "img/Group10.977eb7be.png";